import React from 'react';

interface AddProductContextType {
  jwtToken: any;
  setJwtToken: (jwtToken: any) => void;
  prevState: any;
  setUserToken: (options: any) => void;
  addNewProduct: (options: any) => void;
  clientToken: any;
  primaryMemory: any;
}

const AddProductContext = React.createContext<AddProductContextType | undefined>(undefined);

export default AddProductContext;
